module.exports = __webpack_public_path__ + "img/ru.3b8be0fe.svg";